import React from "react";
import { useQuery } from "@apollo/client";
import Loading from "../../../common/Loading";
import Error from "../../errors/Error";

const withQuery = (query, options) => (Component) => (props) => {
  const { loading, error, data, refetch } = useQuery(query, options);

  if (loading)
    return <Loading />;

  if (error) {
    console.log("Error querying data with Apollo:", error.message);
    return <Error />;
  }

  return <Component
    data={data}
    refetchQuery={refetch}
    // Ignore linter error here since this component is supposed to be a wrapper so we
    // should forward every prop possible
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />;
};

export default withQuery;
